
<div class="agpr-multiText" [class.agpr-multiText--spaced]="bottomMargin">
    <label *ngIf="label" [id]="id + '.label'" class="agpr-multiText-label">
        {{ label | localize }} <span *ngIf="required" class="agpr-multiText-required" aria-hidden="true">*</span>
    </label>
    <div role="group" [attr.aria-labelledby]="id + '.label'" [attr.aria-label]="ariaLabel">
        <ng-container *ngFor="let item of value; let last = last; let index = index; trackBy: trackByFn">
            <div class="agpr-multiText-input">
                <agpr-text-input
                    [id]="id + '.' + index"
                    [(ngModel)]="value[index]"
                    [isEditing]="isEditing"
                    [required]="required"
                    [disabled]="disabled"
                    [bottomMargin]="false"
                    [placeholder]="placeholder"
                    [maxLength]="maxItemLength"
                    (ngModelChange)="onModelChange(value)"
                ></agpr-text-input>
                <span class="agpr-multiText-buttons">
                    <agpr-button
                        *ngIf="last && (!maxItems || value.length < maxItems) && !disabled"
                        (click)="addItem()"
                        class="agpr-multiText-action"
                        [icon]="'fa-regular fa-duotone fa-plus'"
                        [ariaLabel]="'addField' | localize"
                        [tooltip]="'addField' | localize"
                        [style]="buttonTypes.icon"
                    ></agpr-button>
                    <agpr-button
                        *ngIf="value.length > 0 && value.length > minItems && !disabled"
                        (click)="removeItem(index)"
                        class="agpr-multiText-action agpr-multiText-action-trash"
                        [icon]="'fa-regular fa-duotone fa-trash-can'"
                        [ariaLabel]="'deleteField' | localize"
                        [tooltip]="'deleteField' | localize"
                        [style]="buttonTypes.icon"
                    ></agpr-button>
                </span>
            </div>
        </ng-container>
    </div>
</div>
